export default __webpack_public_path__ + "static/apple-icon-180x180-c2dc9ea711c01f7e7a24a0d658755e99.png";